import * as React from 'react';

import ImpressionTracker from '../../../analytics/impression-tracker/ImpressionTracker';
import {ChangeEvent} from 'react';
import {CheckBox} from '../../../ui/forms/CheckBox/CheckBox';
import {GaItemListName} from '../../../../client/ga/ga-ecommerce.functions';
import {OrderableItem} from '../../item.class';
import {Price} from '../../../pricing/Price';
import {Stepper} from '../../../ui/forms/Stepper/Stepper';
import {User} from '../../../users/user.class';

interface ExpertlyCraftedItemProps {
    gaItemListName: GaItemListName;
    item: OrderableItem;
    onCheckUpdate: (itemNum: string, checked: boolean) => void;
    onQtyUpdate: (itemNum: string, unitsOrdered: number) => void;
    orderNumber: string;
    position: number;
    user: User;
}

export const ExpertlyCraftedItem = ({
    gaItemListName,
    item,
    onCheckUpdate,
    onQtyUpdate,
    orderNumber,
    position,
    user,
}: ExpertlyCraftedItemProps) => {
    const componentName = `expertly-crafted-component`;

    /**
     * Template
     */
    return (
        <div className="tw-mt-8 tw-w-full md:tw-w-6/12 lg:tw-w-4/12 tw-mb-3 tw-px-2.5">
            <div className={`tw-flex tw-flex-col tw-h-full ${item.checked ? 'tw-border-4 tw-border-gray-500' : 'tw-border'} tw-bg-white`}>
                {item.onOrder && (
                    <div className="tw-text-white tw-h-8 tw-leading-8 -tw-mt-8 tw-text-center blue-150-bg">Item Added to Order</div>
                )}
                <div className="tw-flex tw-p-2 tw-grow">
                    <div className="tw-w-4/12 tw-text-center">
                        <img
                            alt={item.description}
                            height="120"
                            src={`/ProductImageThumbs120${item.imagePath || '/noimage.png'}`}
                            width="120"
                        />
                    </div>
                    <div className="tw-w-8/12">
                        <div className="tw-pl-3">
                            <div className="tw-mt-3 tw-mb-1">
                                <Price
                                    alias={`${componentName}-${item.item}`}
                                    item={item}
                                    user={user}
                                />
                            </div>
                            <div className="tw-text-sm tw-font-normal tw-leading-[1.3]">
                                Item: {item.prettyItem} | Pkg Qty: {item.pkgQty}
                            </div>
                            <ImpressionTracker
                                data={{
                                    dimension16: orderNumber,
                                    index: position,
                                    item_id: item.item,
                                    item_list_name: gaItemListName,
                                }}
                            >
                                <a href={`/item/${item.item}`}>{item.description}</a>
                            </ImpressionTracker>
                        </div>
                    </div>
                </div>
                <div className="tw-bg-gray-150 tw-p-2 tw-border-t">
                    <div className="tw-flex tw-justify-between tw-items-center">
                        <CheckBox
                            alias={`item-${item.item}`}
                            checked={item.checked || false}
                            label="Select"
                            name={`item-${item.item}`}
                            onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                onCheckUpdate(item.item, event.target.checked);
                            }}
                        />
                        <div className="!tw-w-[123px]">
                            <Stepper
                                disabled={!user.isLoggedIn() || !item.priceInfo}
                                onUpdate={(value) => {
                                    onQtyUpdate(item.item, parseInt(value));
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
